import { Component } from "react";
import * as Sentry from "@sentry/browser";
import { isChunkLoadError, attemptChunkRecoveryReload } from "@/utils/lazyLoad";
import Loading from "@/component/Loading";
import AppError from "@/page/error/AppError.page";

class ErrorBoundary extends Component {
  state = { hasError: false, isChunkError: false, chunkReloadExhausted: false };

  static getDerivedStateFromError(error) {
    const isChunkError = isChunkLoadError(error);
    return {
      isChunkError,
      hasError: isChunkError || import.meta.env.VITE_APP_ARG === "prd",
    };
  }

  componentDidCatch(error, info) {
    if (isChunkLoadError(error)) {
      if (import.meta.env.VITE_APP_ARG === "prd") {
        Sentry.captureException(error, {
          tags: { type: "chunk_load_error" },
          extra: info,
        });
      }

      const reloaded = attemptChunkRecoveryReload();
      if (!reloaded) {
        this.setState({ chunkReloadExhausted: true });
      }
      return;
    }

    if (import.meta.env.VITE_APP_ARG === "prd") {
      Sentry.captureException(error, { extra: info });
    }
  }

  render() {
    if (this.state.isChunkError) {
      return this.state.chunkReloadExhausted ? <AppError variant="chunk" /> : <Loading />;
    }

    if (this.state.hasError) {
      return <AppError variant="runtime" />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
